<template>
  <div class="project-rough-planning">
    <b-row>
      <b-col lg="5" md="5" sm="12">
        <b-form-group
          horizontal
          :label="$t('operationRegistrationAt')"
          label-for="operationRegistrationAt"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackOperationRegistration"
          :state="operationRegisrtationRequirementsState('operationRegistrationAt')"
        >
          <Calendar
            v-model="operationRegistrationAt"
            :placeholder="$t('date')"
            :showWeek="true"
            :disabled="!canWriteField('operationRegistrationAt', guestWritableFields)"
          >
          </Calendar>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('electricMeterChangedAt')"
          label-for="electricMeterChangedAt"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <Calendar
            v-model="electricMeterChangedAt"
            selectionMode="single"
            class="p-column-filter"
            dateFormat="dd.mm.yy"
            :placeholder="$t('date')"
            :showWeek="true"
            :yearNavigator="true"
            :monthNavigator="true"
            yearRange="2019:2025"
            :disabled="!canWriteField('electricMeterChangedAt', guestWritableFields)"
          >
          </Calendar>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('electrician')"
          label-for="electrician"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementsValidState('electrician')"
        >
          <multiselect
            :placeholder="$t('electrician')"
            v-model="project.electrician"
            id="electrician"
            :options="electricians"
            :allow-empty="true"
            :show-labels="false"
            track-by="number"
            label="name"
            :disabled="!canWriteField('electrician', guestWritableFields)"
          >
          </multiselect>
        </b-form-group>
        <b-form-group
          horizontal
          :label="$t('originalInstallationType')"
          label-for="originalInstallationType"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('originalInstallationType')"
            v-model="installation.originalInstallationType"
            :options="getOriginalInstallationTypes"
            :allow-empty="false"
            :selectLabel="$t('press_enter_to_select')"
            :selectedLabel="$t('selected')"
            deselectLabel
            :disabled="!canWriteField('originalInstallationType', guestWritableFields)"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">{{ $t(option) }}</template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="6" md="6" sm="12">
        <template v-if="showToGuest('description', guestVisibleSections)">
          <legend>
            <strong>{{ $t('description') }}</strong>
          </legend>
          <b-form-textarea
            id="description"
            v-model="installation.description"
            placeholder="..."
            rows="8"
            max-rows="8"
            :disabled="!canWriteField('description', guestWritableFields)"
          ></b-form-textarea>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import Calendar from 'primevue/calendar';
import { canWriteField, showToGuest } from '@/helpers/userCapabilities';

export default {
  components: {
    Multiselect,
    Calendar,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      guestWritableFields: {
        operationRegistrationAt: false,
        electricMeterChangedAt: false,
        electrician: false,
        originalInstallationType: false,
        description: false,
      },
      guestVisibleSections: {
        description: false,
      },
    };
  },
  computed: {
    ...mapGetters(['getOriginalInstallationTypes']),

    electricians() {
      return this.project.client && this.project.client.electricians
        ? this.project.client.electricians
        : [];
    },
    installation() {
      if (!this.project.installation) {
        this.$set(this.project, 'installation', {});
      }

      return this.project.installation;
    },
    electricMeterChangedAt: {
      get() {
        return this.$calendarFormat(this.installation.electricMeterChangedAt);
      },
      set(value) {
        this.installation.electricMeterChangedAt = value;
      },
    },
    operationRegistrationAt: {
      get() {
        return this.$calendarFormat(this.installation.operationRegistrationAt);
      },
      set(value) {
        this.installation.operationRegistrationAt = value;
      },
    },
    /**
     * @todo DRY
     */
    invalidFeedbackNA() {
      return 'Voraussetzung NA';
    },
    /**
     * @todo DRY
     */
    invalidFeedbackOperationRegistration() {
      return 'Voraussetzung IN';
    },
  },
  methods: {
    showToGuest,
    canWriteField,
    /**
     * check requirementsValidState to show mark input fields
     * @todo DRY
     */
    requirementsValidState(field) {
      if (!this.project.netRegistrationRequirements) return false;

      const requirement = this.project.netRegistrationRequirements.find(
        (requirement) => requirement.name === field
      );
      return requirement && requirement.fullfilledState === 'YES' ? true : false;
    },
    /**
     * check operationRegisrtationRequirementsState to show mark input fields
     * @todo DRY
     */
    operationRegisrtationRequirementsState(field) {
      if (!this.project.operationRegistrationRequirements) return false;

      const requirement = this.project.operationRegistrationRequirements.find(
        (requirement) => requirement.name === field
      );
      return requirement && requirement.fullfilledState === 'YES' ? true : false;
    },
  },
};
</script>
